export function ourResultsBlock() {
    const $window = $(window);
    const parent = $(".our-results-blocks");

    function mobileSlider() {
        parent.each(function () {
            let $this = $(this);
            if ($window.innerWidth() >= 768) {
                if ($this.hasClass("slick-initialized")) {
                    setTimeout(function () {
                        $this.slick('refresh');
                        $this.slick('unslick');
                    }, 500);
                }
            } else {
                if (!$this.hasClass("slick-initialized")) {
                    $this.slick({
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        infinite: false,
                        arrows: false,
                        dots: false,
                        mobileFirst: true,
                        variableWidth: true,
                    });
                }
            }
        });
    }

    function blocksScroll() {
        let scrollTop = window.scrollY;
        parent.each(function () {
            let $this = $(this);
            if (!$this.hasClass("without-animation")) {
                if (window.innerWidth >= 768) {
                    const blocks = $this.find(".block");
                    let parentOffsetTop = $this.offset().top;
                    if (scrollTop + (window.innerHeight * 0.6) >= parentOffsetTop && scrollTop + (window.innerHeight * 0.6) < parentOffsetTop + 164) {
                        blocks.each((index, block) => {
                            const blockTop = -(index * 75) + ((((scrollTop + (window.innerHeight * 0.6)) - parentOffsetTop) / 2) * index);
                            $(block).css({
                                transform: `translateY(${blockTop}px)`
                            });
                        });
                    }
                } else {
                    $this.find(".block").attr("style", "");
                }
            }
        });

    }

    $window.on("load resize scroll", function () {
        blocksScroll();
    });

    $window.on("load resize", function () {
        setTimeout(() => {
            mobileSlider();
        }, 300);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ourResultsBlock.js